import AsyncStorage from "@react-native-async-storage/async-storage";
import api from "../services/api";

const getLang = async () => {
  const lang = await AsyncStorage.getItem("lang");
  return lang; // Padrão: "pt-BR"
};

const getClientCountry = async () => {
  const clientCountry = await AsyncStorage.getItem("client_country");
  return clientCountry || "brasil"; // Padrão: "brasil"
};

const translate = async (text) => {
  if (typeof text !== "string") {
    return text;
  }
  const lang = await getLang();
  const clientCountry = await getClientCountry();

  // Ignora tradução se o texto contém "USE"
  if (text.includes("USE  LTT/AM23")) {
    return text;
  }
  if (text.includes("USE")) {
    text.replace("USE", "###@#");
  }

  // Traduz somente se o idioma for "it", "en", ou o país for "italia"
  if (lang === "it" || clientCountry === "italia" || lang === "en") {
    try {
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      const targetLanguage =
        lang === "it" || clientCountry === "italia" ? "it" : "en";
      const response = await api.post(
        `/language-translation`,
        { text, target_language: targetLanguage },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const textIt = response?.data?.translation;
      if (textIt.includes("###@#")) {
        textIt.replace("###@#", "USE");
      }

      return response?.data?.translation || text;
    } catch (error) {
      console.error("Error translating text:", error);
      return text; // Retorna o texto original em caso de erro
    }
  }

  // Retorna o texto original em pt-BR
  return text;
};

export default {
  translate,
  getLang,
  getClientCountry,
};
